import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from '@/common/types/errorResponse';
import { AxiosResponse } from 'axios';
import { ClientUserExternalTokenResponse } from "../../types/users/clientUserExternalTokens.type";

interface UseGetClientUserExternalToken {
  tokenId?: string;
  onSuccess?: (reponse: AxiosResponse<ClientUserExternalTokenResponse>) => void;
  onError?: (error: ErrorResponse) => void;
}

const useGetClientUserExternalToken = ({ tokenId, onSuccess, onError }: UseGetClientUserExternalToken) => {
  const privateAxios = usePrivateAxios();

  return useMutation<AxiosResponse<ClientUserExternalTokenResponse>, ErrorResponse>({
    mutationKey: ['getClientUserExternalToken', tokenId],
    mutationFn: () => privateAxios.get(`/client/user_external_tokens/${tokenId}`),
    onSuccess,
    onError,
  });
};

export default useGetClientUserExternalToken;
